export const analyticsId = {
  VIDECALLINFO_VIEW: 'VIDECALLINFO_VIEW',
  CONTINUE_BUTTON: 'CONTINUE_BUTTON',
};

export const catalogue = {
  [analyticsId.VIDECALLINFO_VIEW]: () => ({
    event_name: 'step_identification',
    pageName: '/migration/step02/videocallIdentification',
    sectionFamily: 'banking',
    sectionCategory: 'services',
    sectionName: 'customer',
    interactionType: 'funnel',
    serviceType: 'userSettings',
    processType: 'migration',
    processStep: 'step02',
    processDetail: 'videocallIdentification',
    nombrePagina: 'proc-migracion/paso_2/identificacion por videollamada',
    tipoProceso: 'proc-migracion',
    pasoProceso: 'paso_2',
    detalleProceso: 'identificacion por videollamada',
    tipoPagina: 'generica',
  }),
  [analyticsId.CONTINUE_BUTTON]: () => ({
    categoriaEvento: 'interaccion en migracion',
    accionEvento: 'paso_2',
    etiquetaEvento: 'continuar',
    action: 'continue',
    format: 'button',
    component: 'lowerNavigation',
    element: 'letsGo',
  }),
};
